module.exports = __webpack_public_path__ + "img/supbg1.8c0bde16.jpg";